
import React from 'react';
import ResellerPlanDetailsComponent from '@/components/superadmin/reseller/ResellerPlanDetails';
import AdminAccountsTable from '@/components/superadmin/reseller/AdminAccountsTable';
import { ResellerPlanDetails } from '@/hooks/license/useResellerPlans';
import { AdminAccount } from '@/hooks/useResellerPlanData';

interface ResellerAdminSectionProps {
  currentPlan: ResellerPlanDetails;
  adminAccounts: AdminAccount[];
}

const ResellerAdminSection: React.FC<ResellerAdminSectionProps> = ({
  currentPlan,
  adminAccounts
}) => {
  return (
    <>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
        <div className="lg:col-span-3">
          <ResellerPlanDetailsComponent resellerPlan={currentPlan} />
        </div>
      </div>
      
      <AdminAccountsTable accounts={adminAccounts} />
    </>
  );
};

export default ResellerAdminSection;
